/**
 * 현재 열려있는 바텀시트 수를 전역으로 추적한다.
 *
 * 스와이프 뒤로가기(useSwipeBack) 같은 화면 전역 제스처가, 바텀시트가 열려있는 동안엔
 * 발동하지 않도록 판단하는 데 쓴다. 공용 useSheetDragDismiss 훅이 시트의 open 상태
 * (enabled)에 맞춰 register/해제하므로, 그 훅을 쓰는 모든 시트가 자동으로 반영된다.
 */

let openSheetCount = 0

/** 시트가 열릴 때 호출. 반환된 해제 함수를 닫힘/언마운트 시 호출한다(1회만 적용). */
export function registerOpenSheet(): () => void {
  openSheetCount += 1
  let released = false
  return () => {
    if (released) return
    released = true
    openSheetCount = Math.max(0, openSheetCount - 1)
  }
}

/** 현재 열려있는 바텀시트가 하나라도 있는지 */
export function isAnySheetOpen(): boolean {
  return openSheetCount > 0
}
